import React from 'react';
import PropTypes from 'prop-types';

import { Button, Text } from 'components/common/Elements/Elements';
import AdditionalContent from '../../AdditionalContent/AdditionalContent';

import classes from './CancellationReason.module.scss';

const CancellationReason = ({
  data,
  onOpenAdditionalModal,
  colorForReason
}) => {
  return (
    <div className={classes.wrap}>
      <div
        style={{
          backgroundColor: colorForReason[data.cancellationReason]
        }}
        className={classes.colorBox}
      />
      <Text type="p">
        <Text>{data.cancellationReason}&nbsp;</Text>
        {data.feedback !== '-' ||
        data.feedback !== 'NA' ||
        data.missingFeatures !== '-' ||
        data.missingFeatures !== 'NA' ||
        data.expensiveReasonComment !== '-' ||
        data.expensiveReasonComment !== 'NA' ? (
          <Button
            className={classes.button}
            onClick={() =>
              onOpenAdditionalModal({
                content: <AdditionalContent data={data} />
              })
            }
          >
            more...
          </Button>
        ) : null}
      </Text>
    </div>
  );
};

CancellationReason.propTypes = {
  data: PropTypes.shape({
    cancellationReason: PropTypes.string,
    feedback: PropTypes.string,
    missingFeatures: PropTypes.string,
    expensiveReasonComment: PropTypes.string
  }),
  onOpenAdditionalModal: PropTypes.func,
  colorForReason: PropTypes.object
};

export default CancellationReason;
